<template>
    <div class="page-header" :class="{ 'company-variant': user && (user.is_company || user.is_agent) }">
        <div class="page-header-content d-flex flex-row align-items-center px-3">
            <slot name="action-button">
                <a class="btn me-2" href="#" @click.prevent="$root.$emit('toggleSidebar', true)"
                    style="padding: 4px; height: 35px;">
                    <i class="ri-menu-line" style="font-size: 25px;"
                        :style="{ color: user && (user.is_company || user.is_agent) ? '#fff' : 'initial' }"></i>
                </a>

            </slot>
            <h3 class="me-2" :class="pageHeaderTitleClass">{{ pageName }}</h3>

            <slot name="middle-content">
                <a href="/purchase-credits" v-if="showCreditsLink" class="mx-auto btn btn--empty with-hover"
                    style="color: #fff;">
                    <span class="over-tablet-only">
                        Company credits |
                    </span>
                    {{ user.prospecting_tool_attributes.currentSubscriptionPlan.totalCredits.toLocaleString() || 0 }}
                    <span class="less-tablet-only">
                        credits
                    </span>
                </a>
                <div v-if="user && user.prospecting_tool_attributes && user.prospecting_tool_attributes.canSubscribe"
                    class="mx-auto d-flex align-items-center gap-2">
                    <div class="trial-days-text over-tablet-only" style="font-size: 40px">
                        {{ user.prospecting_tool_attributes.trialRemainingDays || 0 }}
                    </div>
                    <div class="over-tablet-only text-white">Days remaining to activate discount</div>
                    <a href="/pricing" class="btn btn--dark-empty btn--xs align-items-center gap-2">
                        Activate
                        <div class="less-tablet-only">
                            ({{ user.prospecting_tool_attributes.trialRemainingDays || 0 }})
                        </div>
                        <svg width="10" height="17" viewBox="0 0 10 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M1.18202 0.817977L8.72782 8.36377L1.18202 15.9096" stroke="black" />
                        </svg>
                    </a>
                </div>
            </slot>

            <slot name="right-content">
                <a v-if="!hidePostAd" href="/select-advert-type" class="btn btn--primary rounded-10 post-btn ms-auto"
                    :class="{ 'btn--white-empty': user && (user.is_company || user.is_agent) }"
                    style="font-size: var(--font-normal);">Post Ad</a>
                <template v-if="user">
                    <img v-if="user && user.is_company && user.image_url" :src="user.image_url"
                        style="border: 1px solid white;" class="rounded-2 ms-3 cursor-pointer"
                        @click.prevent="showAccountTooltip = true;" height="50"
                        onerror="this.onerror=null;this.src='/img/icons/user.png'" alt="avatar" />
                    <a class="user-menu__icon-link align-items-center mx-2 mx-lg-4" href="#"
                        @click.prevent="showAccountTooltip = true;" v-else>
                        <span class="user-menu__avatar">
                            <img v-if="user.image_url" :src="user.image_url"
                                onerror="this.onerror=null;this.src='/img/icons/user.png'" alt="avatar" />
                            <svg v-else width="18" height="20" viewBox="0 0 18 20">
                                <use xlink:href="#svg-icn-user"></use>
                            </svg>
                        </span>
                    </a>
                </template>

                <div v-show="showAccountTooltip" class="text-small account-tooltip position-absolute" v-on-clickaway="() => {
                    showAccountTooltip = false;
                }">
                    <div class="rounded-2 plan" v-if="user">
                        <strong
                            v-if="user.prospecting_tool_attributes && user.prospecting_tool_attributes.currentSubscriptionPlan">
                            {{ user.prospecting_tool_attributes.currentSubscriptionPlan.nameShort }}
                        </strong>
                        <strong v-else> Freemium Plan </strong>
                    </div>
                    <div class="px-1" style="color: var(--text-color);">
                        <p>{{ pageName }}</p>
                        <hr />
                        <p>Contact support <br />
                            0345 512 0206</p>
                        <a href="/profile" class="text-muted"> Profile </a><br />

                        <a href="/logout" class="text-muted"> Logout </a>
                    </div>
                </div>
            </slot>

        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import { directive as onClickaway } from 'vue-clickaway2';

export default {
    directives: {
        onClickaway,
    },
    props: {
        pageName: {
            type: String,
            required: true,
        },
        hidePostAd: {
            type: Boolean,
            required: false,
            default: false,
        },
        pageHeaderTitleClass: {
            type: String,
            required: false,
        },
    },
    data() {
        return {
            showAccountTooltip: false,
        };
    },
    computed: {
        ...mapState('user', ['user']),
        // A real Subscription, not a SubscriptionAttempt: currentSubscriptionPlan
        // falls back to the attempt, so it is true for people who never paid.
        hasSubscription() {
            return !!(this.user && this.user.prospecting_tool_attributes && this.user.prospecting_tool_attributes.hasSubscription);
        },
        // Keyed on having a plan, not on the balance: a subscriber sitting at zero
        // credits is exactly who needs this link, since it is how they top up.
        showCreditsLink() {
            const routes = ['/purchase-credits', '/prospecting-tool', '/letter-sending'];
            if (!this.hasSubscription) return false;

            return routes.some((route) => this.$route.path.includes(route));
        },
    },
};
</script>
